import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(10),
  margin: '0 auto',
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(8),
  },
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(3),
  },
  '& #main_blog_body': { 
    backgroundColor: 'transparent !important',
    border: 'none !important',
    borderRadius: '0 !important',
    padding: '0 !important',
  },
  '& a': {
    color: `${theme.palette.common.white} !important`,
    fontWeight: '700 !important',
    textDecoration: 'underline !important',
    textTransform: 'none !important',
  },
  '& p': {
    color: `${theme.palette.text.secondary} !important`,
  },
  '& img, video': {
    maxWidth: '100% !important',
  },

}));
export default StyledBox;